/**
 * @file Shared React component — components/Layout/SidebarFooter.tsx.
 */

import React, { useState } from "react";
import CiteModal from "../common/CiteModal";
import { useToolCitation } from "../../hooks/useToolCitation";

const SidebarCiteButton: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { menuTitle, description } = useToolCitation();

  return (
    <>
      <button className="bottom-btn" onClick={() => setModalOpen(true)}>
        {menuTitle}
      </button>
      <CiteModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        menuTitle={menuTitle}
        description={description}
      />
    </>
  );
};

type SidebarFooterProps = {
  showCiteButton?: boolean;
};

const SidebarFooter: React.FC<SidebarFooterProps> = ({ showCiteButton = true }) => {
  return (
    <div className="sidebar-bottom">
      {showCiteButton ? <SidebarCiteButton /> : null}
      <p className="bottom-text">CEPT Research Platform © {new Date().getFullYear()}</p>
    </div>
  );
};

/** React component — Sidebar Footer. */
export default SidebarFooter;
